define('modules/T1App/edit/team/views/bin',["jQuery", "Underscore", "T1", "T1View", "T1Comm", "text!modules/T1App/edit/team/templates/bin.html", "T1Model", "T1Layout"], function ($, _, T1, T1View, T1Comm, template) {
  "use strict";

  var MetaTeamBinCreateEdit;
  var T1Publish = T1.EventHub.publish;
  MetaTeamBinCreateEdit = T1View.extend({
    template: template,
    events: {
      "click .remove-dev ": "binClickHandler"
    },
    initialize: function (args) {
      this.model = args.model;
    },
    load: function () {
      var model = this.model;
      this.render().then(function () {
        _.each(model.devTeam, function (value) {
          $(".dev-team-container").append('<div id="' + value.user_id + '" class="dev-team">' + value.email + '<strand-icon class="icon remove-dev pull-right" type="delete" width="10" height="10"></strand-icon></div>');
        });
      });
    },
    binClickHandler: function (event) {
      T1Publish("change:binElements", event);
    },
    render: function () {
      var $el = this.el;
      var deferred = $.Deferred();
      if ($el[0] && Polymer && Polymer.dom) {
        Polymer.dom($el[0]).innerHTML = template;
      } else {
        $el.html(template);
      }
      $el.css("visibility", "visible");
      $el.addClass("fade-in");
      this.buildPermissionedEvents();
      this.bindViewEvents();
      setTimeout(function () {
        deferred.resolve();
      }, 0);
      return deferred.promise();
    }
  });
  return MetaTeamBinCreateEdit;
});
